export const featureFlags = {
  RAZORPAY_ENABLED: 'RAZORPAY_ENABLED',
}
